import React from "react";
import CommonCard from "../../component/commonCard/commonCard";

const Dashboard = () => {
  return (
    <div>
      
      <CommonCard/>
 </div>

  );
};

export default Dashboard;
